import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { InlineFilter } from 'shared/components/InlineFilter';
import { BX_COMISSION_FILTER_EXPERIMENT } from 'shared/constants/experiments';
import { useExperiment, useFilterChangeCallback } from 'shared/hooks';
import { selectDealTypeFilter } from 'shared/selectors/advancedFilters';

export const DealTypeContainer: FC = () => {
  const isRentCommissionFilterEnabled = useExperiment(BX_COMISSION_FILTER_EXPERIMENT);

  const { label, value, visible } = useSelector(selectDealTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleIsByHomeownerChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setIsByHomeowner', arguments: [newValue || null] });
    },
    [onChange],
  );

  if (!visible || isRentCommissionFilterEnabled) {
    return null;
  }

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilter>
        <Checkbox label="От собственника" checked={!!value} onChange={handleIsByHomeownerChange} />
      </InlineFilter>
    </AdvancedFilterRow>
  );
};
